import { InitialsCaptureModal } from '@/features/order/ui/initials-capture-modal'

/**
 * BD-8595: initials step for the onboarding tutorial (TMI flag).
 * Reuses production InitialsCaptureModal so desktop/mobile open the same way
 * (centered Modal vs bottom Drawer). Non-interactive — Next on the Driver.js
 * popover advances the tutorial.
 */
export function InitialsTutorialOverlay() {
  return (
    <InitialsCaptureModal
      opened
      tutorialMode
      onSubmit={() => {}}
    />
  )
}
